import * as React from "react";

interface OutwardHeadingProps {
  kindLabel: string;
  status?: string | null;
}

const STATUS_PILL: Record<string, { label: string; background: string; color: string }> = {
  NEW: { label: "Chưa lưu", background: "#E9EBE6", color: "#4A525C" },
  OPEN: { label: "Lưu tạm", background: "#E6EEF8", color: "#1F5FAE" },
  LOCK: { label: "Đã xuất", background: "#E4F2EA", color: "#14532F" },
};

/** Loại phiếu và trạng thái: đầu khối Thông tin chung, hoặc thanh trên cùng khi khối bị ẩn */
const OutwardHeading = ({ kindLabel, status }: OutwardHeadingProps) => {
  const pill = STATUS_PILL[status || "NEW"] ?? { label: status ?? "", background: "#E9EBE6", color: "#4A525C" };
  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 10, minWidth: 0 }}>
      <span style={{ color: "#B42318", fontWeight: 700, whiteSpace: "nowrap" }}>Loại phiếu</span>
      <span
        style={{
          padding: "4px 10px",
          borderRadius: 8,
          background: "#FFFFFF",
          border: "1px solid #D5D9D2",
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        {kindLabel}
      </span>
      <span
        style={{
          padding: "3px 10px",
          borderRadius: 999,
          background: pill.background,
          color: pill.color,
          fontSize: 12,
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        {pill.label}
      </span>
    </div>
  );
};

export default OutwardHeading;
